<template>
  <p-list />
</template>

<script>
import List from './../components/reports/List.vue';
export default {
  components: {
    'p-list': List
  }
};
</script>
